angular
.module('vppApp')
.controller('verifyUserController', verifyUserController);

verifyUserController.$inject = ['$location', '$rootScope', 'apiFactory', 'ThirdPartyMessages'];

function verifyUserController($location, $rootScope, apiFactory, ThirdPartyMessages) {

    var thisUrl = $location.path();
    var pathSections = thisUrl.split('/');
    if (pathSections[1] === 'confirm') {
        apiFactory.verifyEmail($location.$$search["token"])
            .then(function successVerification(response)  {
                ThirdPartyMessages.setMessage('verification', '');
                $location.path('');
            },function errorCallback(response) {
                ThirdPartyMessages.setMessage('verificationFail', 'error');
                $location.path('');
        });
    }
};

